<template>
  <div :class="`auth-flash-msg auth-flash-msg--${type}`">
    <span>{{ msg }}</span>
    <button class="auth-flash-msg__close" @click="handleClose">Close</button>
  </div>
</template>

<script>
export default {
  name: 'AuthFlashMsg',

  props: {
    type: {
      type: String,
      required: false,
      default: 'info',
      validator: (value) => {
        return ['info', 'success', 'warning', 'danger'].includes(value)
      },
    },

    msg: { type: String, required: false, default: '' },
  },

  methods: {
    handleClose() {
      this.$emit('close')
    },
  },
}
</script>

<style scoped lang="scss">
.auth-flash-msg {
  position: relative;
  padding: rem(8) rem(32);
  border-radius: rem(10) rem(10) 0 0;
  text-align: center;
  white-space: pre-line;
  font-family: $font-bold;
  font-size: rem(14);
  line-height: rem(16);

  &--info {
    background-color: rgba($black, 0.1);
    color: $black;
  }

  &--success {
    background-color: rgba($green, 0.15);
    color: $green;
  }

  &--warning {
    background-color: rgba($yellow, 0.15);
    color: $yellow;
  }

  &--danger {
    background-color: rgba($red, 0.15);
    color: $red;
  }

  &__close {
    position: absolute;
    right: rem(4);
    top: rem(4);
    width: rem(24);
    height: rem(24);
    font-size: 0;
    transition: opacity 0.2s linear;
  }

  [dir='rtl'] &__close {
    left: rem(4);
    right: unset;
  }

  &__close:after {
    content: '\e932';
    @include inline-icon;
    font-size: rem(16);
  }

  &__close:hover {
    opacity: 0.6;
  }
}
</style>
